import { useDispatch, useSelector } from 'react-redux';
import { kanbanColumnCardsSelector } from '../../redux/selectors/kanban';
import { moveKanbanCardToColumn } from '../../redux/actions/kanban';
import { IKanbanActions } from '../../types/layout/kanban';
import useRest from '../useRest';

interface IUseKanbanColumnOptions {
    column: string;
    kanbanActions?: IKanbanActions;
}

export const useKanbanColumn = ({ column, kanbanActions }:IUseKanbanColumnOptions) => {
    const dispatch = useDispatch();
    const cards = useSelector(kanbanColumnCardsSelector(column));
    const rest = useRest();

    const moveCard = (card: string) => {
        dispatch(moveKanbanCardToColumn(card, column));
    };

    const onCardDrop = (item: {id: string}) => {
        if (typeof kanbanActions?.drop === 'string') {
            const index = cards.findIndex((el) => el.id === item.id);

            rest.fetch({
                objectName: kanbanActions.drop,
                method: 'post',
                data: {
                    bottomCard: cards[index + 1]?.id || null,
                    topCard: cards[index - 1]?.id || null,
                    card: cards[index],
                },
            });
        }
    };

    return {
        cards,
        moveCard,
        onCardDrop,
    };
};
